exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.emptyBox[data-v-5fec2d12] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.emptyImg[data-v-5fec2d12] {\n  width: 4.03rem;\n  height: 3.28rem;\n  background: url(" + require("assets/artHealing.png") + ") no-repeat center/cover;\n  margin-top: 2rem;\n  margin-bottom: 0.62rem;\n  font-size: 0.3rem;\n  color: #6f6f6f;\n}\n.emptyName[data-v-5fec2d12] {\n  font-size: 0.32rem;\n  color: #000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fec2d12","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/myCourse.vue
// module id = 8IwY
// module chunks = 1